var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82788 2.3699L2.59888 7.56091C2.41283 7.74582 2.16123 7.84961 1.89893 7.84961C1.63662 7.84961 1.3849 7.74582 1.19885 7.56091C1.10721 7.47016 1.03451 7.36214 0.984863 7.2431C0.935217 7.12407 0.909668 6.99637 0.909668 6.8674C0.909668 6.73843 0.935217 6.61073 0.984863 6.4917C1.03451 6.37266 1.10721 6.26467 1.19885 6.17392L7.12695 0.288909C7.313 0.104002 7.5646 0.000212995 7.8269 0.000213018C8.08921 0.000213041 8.34081 0.104002 8.52686 0.288909L14.455 6.17392C14.5466 6.26467 14.6193 6.37266 14.6689 6.4917C14.7186 6.61073 14.7441 6.73843 14.7441 6.8674C14.7441 6.99637 14.7186 7.12407 14.6689 7.2431C14.6193 7.36214 14.5466 7.47016 14.455 7.56091C14.2689 7.74582 14.0172 7.84961 13.7549 7.84961C13.4926 7.84961 13.241 7.74582 13.0549 7.56091L7.82788 2.3699Z",
    fill: "#8A939F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.6f4535b267cd1e8c22f835374b23f520.svg";
export { ForwardRef as ReactComponent };